import { OPEN_DISCARD_DIALOG, CLOSE_DISCARD_DIALOG } from "redux/constants/flowDesigner";

const initialState = {
  showDiscardDialog: false
};

const common = (state = initialState, action) => {
  switch (action.type) {
    case OPEN_DISCARD_DIALOG:
      return {
        ...state,
        showDiscardDialog: true
      };
    case CLOSE_DISCARD_DIALOG:
      return {
        ...state,
        showDiscardDialog: false
      };
    default:
      return state;
  }
};

export default common;
